var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoSound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    viewBox: "0 0 48 48",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M23.935 13a1 1 0 0 0-.624.219l-6.354 5.078H12a1 1 0 0 0-1 1v8.482a1 1 0 0 0 1 1h4.944l6.367 5.089a1 1 0 0 0 .624.219h1.855a1 1 0 0 0 1-1V14a1 1 0 0 0-1-1zm-5.627 6.778L24.285 15h.505v17.087h-.505l-5.977-4.778zm-5.308 7v-6.481h3.308v6.482z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.05 20.584a1 1 0 0 1 1.414 0 4.176 4.176 0 0 1 0 5.918 1 1 0 1 1-1.415-1.414 2.176 2.176 0 0 0 0-3.09 1 1 0 0 1 0-1.414Zm4.832-2.251a1 1 0 0 0-1.414 1.414 5.36 5.36 0 0 1 0 7.58 1 1 0 0 0 1.414 1.415 7.36 7.36 0 0 0 0-10.41Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSound);
export default __webpack_public_path__ + "static/media/IcoSound.ef926048270cb969b6a40359bfa70bde.svg";
export { ForwardRef as ReactComponent };